export default {
  name: "Auth",
  path: "/auth",
  component: () => import("../../views/auth/login.vue"),
  beforeEnter: (to, from, next) => {
    const { auth, level } = localStorage;
    auth === "true" ? next({ name: level }) : next();
  },
  children: [
    {
      name: "Login",
      path: "login/:operator",
    },
    {
      name: "LoginCollaborator",
      path: "collaborator/login/:operator",
    },
  ],
};
